import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { filmCredits, albums } from "../data/mock";
import YouTubePlayer from "../components/YouTubePlayer";
import AlbumCard from "../components/AlbumCard";
import { Reveal } from "../hooks/useReveal";

const FilmCredits = () => {
  const filmAlbums = albums.filter((a) => a.category === "film");
  return (
    <div className="bg-[#f4f1ec] text-black">
      <section className="pt-32 md:pt-40 pb-10">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
          <Reveal>
            <h1
              className="text-3xl md:text-5xl lg:text-6xl tracking-tight font-semibold"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Documentary <span className="text-neutral-400 font-light">|</span>{" "}
              Feature Film{" "}
              <span className="text-neutral-400 font-light">|</span> Short Film
            </h1>
          </Reveal>
          <Reveal delay={80}>
            <p className="mt-5 text-neutral-600 text-base md:text-lg">
              Original scores for the screen.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-10">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {filmCredits.posters.map((src, i) => (
            <Reveal key={i} delay={i * 50}>
              <div className="aspect-[2/3] overflow-hidden rounded-md shadow-md group bg-neutral-200">
                <img
                  src={src}
                  alt={`Film poster ${i + 1}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <hr className="my-12 border-black/10 max-w-[1200px] mx-auto" />

      <section className="py-12">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <Reveal>
            <h2
              className="text-2xl md:text-4xl font-medium tracking-tight mb-10"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Film Soundtracks
            </h2>
          </Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {filmAlbums.map((a, i) => (
              <Reveal key={a.id} delay={i * 60}>
                <AlbumCard album={a} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-20 pt-8">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <Reveal>
            <h2
              className="text-2xl md:text-4xl font-medium tracking-tight mb-10"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Scores &amp; Rescores
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {filmCredits.videos.map((v, i) => (
              <Reveal key={i} delay={i * 60}>
                <YouTubePlayer videoId={v.youtubeId} title={v.title} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 border-t border-black/10">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12 flex items-center justify-between">
          <Link
            to="/work/game-credits"
            className="group inline-flex items-center gap-2 text-black font-medium"
          >
            <ArrowLeft className="w-5 h-5 transition-transform group-hover:-translate-x-1" />
            <span>
              <span className="block text-xs uppercase tracking-[0.18em] text-neutral-500">
                Previous
              </span>
              Game Credits
            </span>
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 text-neutral-700 hover:text-black transition-colors"
          >
            Contact <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default FilmCredits;
